import React from 'react';
import './style.scss';
const PaginationControls = ({ currentPage, totalPages, onPageChange, style ={} }) => {
  return (
    <div className="togglePages" style={{ display: "flex",  alignItems: "center",  justifyContent: "center",  gap: "1rem",  fontSize: "16px" ,   fontWeight: "600"}}>
      {currentPage > 1 ? (
        <p  style={{ cursor: 'pointer', margin: 0 }}  onClick={() => onPageChange('prev')}  id="prev"  >   Previous  </p>
      ) : (
        <p style={{ margin: 0 }}></p>
      )}

      <p style={{ margin: 0 }}>
        {currentPage}/{totalPages}
      </p>

      {currentPage < totalPages ? (
        <p style={{ cursor: 'pointer', margin: 0 }} onClick={() => onPageChange('next')} id="next"  >   Next </p>
      ) : (
        <p style={{ margin: 0 }}></p>
      )}
    </div>
  );
};

export default PaginationControls;
